import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

type Props = {
  lancaster: number | string;
  york: number | string;
  type: "Game" | "Roses";
};

const Score = ({ lancaster, york, type }: Props) => {
  return (
    <Box mt={3} mb={5}>
      <Flex gap={3} mb={3} justifyContent="space-around">
        <Box textAlign="center" color={type === "Roses" ? "red.200" : "white"}>
          <Text fontSize="6xl" fontWeight="bold">
            {lancaster}
          </Text>
          <Text fontWeight="bold" fontFamily="Graduate">
            LANCASTER
          </Text>
        </Box>

        <Box
          textAlign="center"
          color={type === "Roses" ? "yellow.200" : "white"}
        >
          <Text fontSize="6xl" fontWeight="bold">
            {york}
          </Text>
          <Text fontWeight="bold" fontFamily="Graduate">
            YORK
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default Score;
